import Swiper from "swiper";

export const createComponentsPassagensInternacionais = () => {
	if (document.body.className.match(".passagens-internacionais")) {
		const destinationInternational = () => {
			const destinationInternationalsParent = document.querySelector(
				"#swiper-destination-international"
			).parentElement.parentElement;

			destinationInternationalsParent.classList.remove("hide");

			const swiperDestinationInternational = new Swiper(
				"#swiper-destination-international .swiper-container",
				{
					pagination: {
						el: "#swiper-destination-international .swiper-pagination",
						clickable: true
					},
					simulateTouch: false,
					slidesPerView: 3,
					slidesPerGroup: 3,
					slidesPerColumn: 1,
					spaceBetween: 30,
					navigation: {
						nextEl: "#swiper-destination-international .swiper-button-next",
						prevEl: "#swiper-destination-international .swiper-button-prev",
					},
					breakpoints: {
						768: {
							simulateTouch: true,
							slidesPerView: 1,
							slidesPerGroup: 1,
							slidesPerColumn: 1
						}
					}
				}
			);
		};

		destinationInternational();
	}
};
